"use client";

import React from "react";
import { Box } from "@mui/material";
import { useIsVariant } from "@/hooks/useVariant";

/**
 * Default Logo Component (NADA/ATD variant)
 *
 * Displays either NADA or ATD logo based on vehicle type.
 * This is the default variant used when NEXT_PUBLIC_VARIANT is not set or is "nada".
 */
export default function Logo() {
    const isATD = useIsVariant("atd");
    const isCada = useIsVariant("cada");

    return (
        <Box>
            {isCada ? (
                <img
                    src="/CADA_logo.jpg"
                    alt="CADA Logo"
                    style={{ height: 82, marginBottom: 24 }}
                />
            ) : (
                <img
                    src={isATD ? "/atd-login.png" : "/nada-login.svg"}
                    alt={isATD ? "ATD Logo" : "NADA Logo"}
                    style={{ height: 82, marginBottom: 24 }}
                />
            )}
        </Box>
    );
}
